import { Component, Input } from '@angular/core';

import { ProfileType } from '@fcom/core-api/login';

@Component({
  selector: 'fin-loyalty-view',
  templateUrl: './loyalty-view.component.html',
  styleUrls: ['./loyalty-view.component.scss'],
  standalone: false,
})
export class LoyaltyViewComponent {
  @Input()
  pageTitle: string;

  @Input()
  profileType = ProfileType.FPLUS;

  @Input()
  showPlusCard = false;

  @Input()
  showAnnouncementCard = false;

  @Input()
  constrainBenefitBanner = false;

  @Input()
  showHeroBackground = false;

  @Input()
  showGoldHeroBackground = false;
}
